import { useTranslation } from "react-i18next";
import { InfoText } from "../../core/components/texts/InfoText";
import { AppointmentScreenWrapper } from "../onboarding/AppointmentScreenWrapper";
import { useNavigateToReturnUrl } from "./utils/useNavigateToReturnUrl";

/**
 * PF-5483 dead end: the practice requires a prescription. Recovery runs through the back button — this
 * screen is entered with a push, so it leads back to the recipe choice where uploading or self-paying are
 * still open. PF-5480 removed the former 10s auto-redirect to the practice selection: it pulled the notice
 * away while the patient was still reading it, and with the selection screen's guards it could bounce.
 */
export const AppointmentNotPossibleScreen = () => {
  const { t } = useTranslation();
  const { appointmentReturnUrl, navigateToReturnUrl, returnButtonText } =
    useNavigateToReturnUrl();

  return (
    <AppointmentScreenWrapper
      onNext={appointmentReturnUrl ? navigateToReturnUrl : undefined}
      nextButtonText={appointmentReturnUrl ? returnButtonText : undefined}
      hideNextButton={!appointmentReturnUrl}>
      <InfoText
        headline={t("APPOINTMENT_ERROR_HEADLINE")}
        text={[t("APPOINTMENT_ERROR_DESCRIPTION")]}
      />
    </AppointmentScreenWrapper>
  );
};
